import { render } from "./Brand.vue?vue&type=template&id=6775f574&scoped=true&ts=true"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"

import "./Brand.vue?vue&type=style&index=0&id=6775f574&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6775f574"]])

export default __exports__